export const reduxKey = 'environment';

//# sourceMappingURL=constants.js.map